var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4162 0.334961H2.38598C1.29195 0.334961 0.335449 1.12267 0.335449 2.2042V22.2782C0.335449 23.366 1.29195 24.335 2.38598 24.335H22.4099C23.5102 24.335 24.3354 23.3597 24.3354 22.2782V2.2042C24.3417 1.12267 23.5102 0.334961 22.4162 0.334961ZM7.77331 20.3403H4.33492V9.65003H7.77331V20.3403ZM6.1729 8.02293H6.14789C5.04761 8.02293 4.33492 7.20396 4.33492 6.17869C4.33492 5.13467 5.06636 4.33446 6.19165 4.33446C7.31694 4.33446 8.00462 5.12842 8.02963 6.17869C8.02963 7.20396 7.31694 8.02293 6.1729 8.02293ZM20.3409 20.3379H16.9025V14.4926C16.9025 13.0922 16.4023 12.1357 15.1583 12.1357C14.208 12.1357 13.6454 12.7796 13.3953 13.4048C13.3015 13.6299 13.2765 13.9362 13.2765 14.2488V20.3379H9.83814V9.64757H13.2765V11.1355C13.7767 10.4228 14.5581 9.39751 16.3773 9.39751C18.6342 9.39751 20.3409 10.8854 20.3409 14.0925V20.3379Z",
    fill: "#014971"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.0ab39c082ff8489ea1e8cf31509dd91b.svg";
export { ForwardRef as ReactComponent };